import { render, staticRenderFns } from "./function-block.vue?vue&type=template&id=46dbc98f&scoped=true"
import script from "./function-block.vue?vue&type=script&lang=js"
export * from "./function-block.vue?vue&type=script&lang=js"
import style0 from "./function-block.vue?vue&type=style&index=0&id=46dbc98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dbc98f",
  null
  
)

export default component.exports